import { Box, Divider, Layout, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { convertElementStatusToBooleanStatus, RuleFooter } from '@wix/rules-panel-ui';
import React, { useEffect } from 'react';
import { BiCtaNames } from '../../../../../bi/types';
import { HTTP_PREFIX } from '../../../../../consts';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { dataHooks } from '../../../../../utils/datahooks';
import { originalImageUrl, resolveImageUrl } from '../../../../../utils/resolve-image-url';
import { PreviewImage } from './preview-image';
const MAX_IMAGES = 4;
export const AltTextImageGrid = _ref => {
  let {
    images,
    onClickCancel,
    openDrillInScreen,
    taskStatus
  } = _ref;
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const preloadImagesUrl = () => images.forEach(image => {
      if (image.url.startsWith(HTTP_PREFIX)) {
        const img = new Image();
        img.src = image.url;
        return;
      }
      const bigImg = new Image();
      bigImg.src = originalImageUrl(image.url);
      const smallImg = new Image();
      smallImg.src = resolveImageUrl(image.url, 32, 32);
    });
    preloadImagesUrl();
  }, [images]);
  const biLogger = useBiLogger();
  const hasMore = images.length > MAX_IMAGES;
  const displayedImages = [...images.filter(image => !convertElementStatusToBooleanStatus(image.status)), ...images.filter(image => convertElementStatusToBooleanStatus(image.status))].slice(0, MAX_IMAGES);
  const leftImagesCount = images.length - MAX_IMAGES;
  const passElementsAsImages = images.filter(_ref2 => {
    let {
      status
    } = _ref2;
    return convertElementStatusToBooleanStatus(status);
  }).length;
  const failedElementsAsImages = images.length - passElementsAsImages;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.altTextImageGridWrapper,
    direction: "vertical",
    width: "100%"
  }, taskStatus && /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    marginBottom: "SP2",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    marginBottom: "SP1"
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: dataHooks.altTextImageGridFilledImagesText,
    size: "tiny",
    skin: "standard",
    weight: "thin"
  }, t('accessibility-wizard.alt-text.overview-section.progress-bar.filled', {
    filledAmount: passElementsAsImages,
    totalAmount: images.length
  })), taskStatus && /*#__PURE__*/React.createElement(TextButton, {
    dataHook: dataHooks.altTextImageGridEditButton,
    size: "tiny",
    onClick: () => {
      biLogger.taskCtaClick({
        ctaName: BiCtaNames.Edit,
        elementCount: images.length,
        failedElementCount: failedElementsAsImages
      });
      openDrillInScreen();
    }
  }, t('accessibility-wizard.alt-text.completed-task.edit'))), /*#__PURE__*/React.createElement(Layout, {
    cols: MAX_IMAGES + 1,
    gap: "2px"
  }, displayedImages.map(image => /*#__PURE__*/React.createElement(PreviewImage, {
    dataHook: dataHooks.altTextImageGridPreviewImage,
    image: image,
    key: image.id
  })), hasMore && /*#__PURE__*/React.createElement(Box, {
    align: "center",
    border: "1px solid",
    borderColor: "D70",
    borderRadius: "4px",
    boxSizing: "border-box",
    dataHook: dataHooks.altTextImageGridMoreImages,
    height: "50px",
    position: "relative",
    verticalAlign: "middle",
    width: "50px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    skin: "standard",
    weight: "thin"
  }, `+${leftImagesCount}`))), /*#__PURE__*/React.createElement(Box, {
    align: "right",
    marginTop: "SP2",
    width: "100%"
  }, !taskStatus && /*#__PURE__*/React.createElement(RuleFooter, {
    dataHook: dataHooks.altTextImageGridRuleFooter,
    dismissButtonProps: {
      label: t('accessibility-wizard.rules-list.alt-text.button.cancel'),
      onClick: () => {
        biLogger.taskCtaClick({
          ctaName: BiCtaNames.Cancel,
          elementCount: images.length,
          failedElementCount: failedElementsAsImages
        });
        onClickCancel();
      }
    },
    submitButtonProps: {
      label: t('accessibility-wizard.rules-list.alt-text.button.get-started'),
      onClick: () => {
        biLogger.taskCtaClick({
          ctaName: BiCtaNames.GetStarted,
          elementCount: images.length,
          failedElementCount: failedElementsAsImages
        });
        openDrillInScreen();
      }
    }
  })));
};
export default AltTextImageGrid;
//# sourceMappingURL=alt-text-image-grid.js.map